export type FieldType =
  | "string"
  | "number"
  | "integer"
  | "boolean"
  | "object"
  | "array"
  | "enum"
  | "oneOf"
  | "anyOfTabs"
  | "quantity"
  | "diffPreview";

export interface BranchDiff {
  fromTitle: string;
  toTitle: string;
  toBranchIndex: number;
  removed: string[];
  added: string[];
  parentRowId: string;
}

export type FieldPath = (string | number)[];

export interface OneOfBranchInfo {
  index: number;
  title: string;
  discriminatorValue: string | number | null;
  schema: any;
}

export interface OptionalChildInfo {
  key: string;
  label: string;
  schema: any;
  defaultValue: unknown;
}

export interface FormRow {
  id: string;
  path: FieldPath;
  parentId: string | null;
  fieldName: string;
  label: string;
  fieldType: FieldType;
  value: unknown;
  defaultValue?: unknown;
  required: boolean;
  schema: any;
  isOptionalSectionParent: boolean;
  optionalSectionEnabled: boolean;
  isAdditionalPropsParent: boolean;
  isAdditionalPropsChild: boolean;
  enumOptions?: { value: unknown; label: string }[];
  useEndpoint?: string;
  isSecret: boolean;
  isDirty: boolean;
  errorMessage?: string;
  errorSeverity?: "error" | "warning";
  isDisabled: boolean;
  disabledReason?: string;
  oneOfBranches?: OneOfBranchInfo[];
  activeOneOfIndex?: number;
  discriminatorKey?: string;
  optionalChildren?: OptionalChildInfo[];
  itemsSchema?: any;
  diff?: BranchDiff;
  children?: FormRow[];
}

export const ROOT_PATH: FieldPath = [];
export const ROOT_ID = "__root__";

export const pathToId = (path: FieldPath): string =>
  path.length === 0 ? ROOT_ID : path.map(String).join(".");

export const prettify = (name: string): string =>
  name
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
